import Swal from 'sweetalert2';

export function useSwalFire() {
    const rootStyles = getComputedStyle(document.documentElement);

    function onDeleteNotify () {
        return Swal.fire({
            title: "¿Está seguro de borrar este registro?",
            text: "Esta acción no se puede deshacer!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: rootStyles.getPropertyValue('--primary-color').trim(),
            cancelButtonColor: rootStyles.getPropertyValue('--danger-color').trim(),
            confirmButtonText: "¡Sí, borrar!",
            cancelButtonText: "Cancelar",
            heightAuto: false,
        })
    }

    function onSuccessNotify (config = {label: 'Operación exitosa', title: '¡Éxito!', showCancelButton: false}) {
        const {label, showCancelButton, title} = config
        
        return Swal.fire({
            icon: 'success',
            title: title,
            text: label,
            showCancelButton: showCancelButton,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cerrar'
        });
    }

    function onErrorNotify (config = {label: 'Ocurrio un error inesperado.', title: 'Error!'}) {
        const {label, title} = config

        return Swal.fire({
            icon: 'warning',
            title: title,
            text: label,
            confirmButtonText: 'Regresar',
        });
    }

    function onCatchError (errorException) {
        let message = errorException.response ? errorException.response.data : errorException
        return Swal.fire({
            icon: 'warning',
            title: 'Algo salió mal',
            text: `El servidor respondió con: ${JSON.stringify(message)}`,
            confirmButtonText: 'Cerrar',
        });
    }

    return {onDeleteNotify, onSuccessNotify, onErrorNotify, onCatchError}
}